import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { Policy } from '../../interfaces/auth/policy';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';

export class RoleConfig implements IConfigObjectBase {
	id = Guid();
	name = '';
	description?: string;
	dateCreated = DateTime.now();
	lastUpdated = DateTime.now();
	objectState?: ObjectState;
	isSystemRole?: boolean;

	policies: Policy[] = [];

	constructor(init?: Partial<RoleConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
